module.exports = __webpack_public_path__ + "img/pasos1-3.12c15abd.png";